import { api as gridApi } from './shipmentLotsGridActions';
import {getShipmentDetails} from '../../services/Shipments/shipmentsService';
import Network from 'infrastructure/js/modules/network';
import {api as messageDialogApi} from '../MessageDialog/messageDialogActions';


// /////////////////////////////////////////
// // ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  SHIPMENT_PAGE_SET_SHIPMENT_ID: 'SHIPMENT_PAGE_SET_SHIPMENT_ID',
  SHIPMENT_PAGE_UNMOUNT: 'SHIPMENT_PAGE_UNMOUNT',
};

// ////////////////////////////////////////////////////////////////
// // PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY

const actions = {
  setShipmentId: function(payload) {
    return {type: actionTypes.SHIPMENT_PAGE_SET_SHIPMENT_ID, payload: payload };
  },
  unmount: function() {
    return {type: actionTypes.SHIPMENT_PAGE_UNMOUNT};
  },
};


// /////////////////////////////////////////////////////
// // METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE

export let jsxActions = {};

jsxActions.reload = function () {
  return function (dispatch, getState) {
    gridApi.reload(dispatch, getState)();
  }
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  };
};

jsxActions.setShipmentId = function (cocId) {
  return function (dispatch, getState) {
    dispatch(actions.setShipmentId(cocId));
  }
};

jsxActions.init = function (shipmentId) {
  return function (dispatch, getState) {
    return api.fetchData(dispatch, getState)(shipmentId);
  };
};

jsxActions.unmount = function() {
  return function(dispatch, getState) {
    dispatch(actions.unmount());
  }
};


// /////////////////////////////////////////////////////////////////////////
// // API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)

export let api = {};

api.fetchData = function(dispatch, getState) {
  return function(shipmentId) {
    return getShipmentDetails(shipmentId).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Fetch the shipment details failed', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }

      return response.data;

    })
      .catch((error) => {
        console.error('Fetch the shipment details failed', error);
        return {success: false};
      });
  }
}
